/* global femcare */

femcare.quiz.base = {
    init: function() {
        if (!$('.quiz').length) {
            return;
        }

        function BaseQuiz($quiz) {
            this.id = window.quiz.id;
            this.postUrl = window.quiz.postUrl;

            this.$quiz = $quiz;
            this.$intro = this.$quiz.find('.quiz-intro');
            this.$questionnaire = this.$quiz.find('.questionnaire');
            this.$steps = this.$questionnaire.find('.questionnaire__step');
            this.$result = this.$quiz.find('.quiz-result');

            this.initBaseEventHandlers();
            if (this.initDerivedEventHandlers) {
                this.initDerivedEventHandlers();
            }
        }

        BaseQuiz.prototype.initBaseEventHandlers = function() {
            var $start = this.$quiz.find('.quiz__start');
            $start.click($.proxy(this.start, this));

            var $next = this.$questionnaire.find('.questionnaire__next');
            $next.click($.proxy(this.next, this));

            var $previous = this.$questionnaire.find('.questionnaire__previous');
            $previous.click($.proxy(this.previous, this));

            var $restart = this.$quiz.find('.quiz__restart');
            $restart.click($.proxy(this.restart, this));

            var $answers = this.$questionnaire.find('input, select');
            $answers.change(function() {
                $(this).validate();
            });
        };

        BaseQuiz.prototype.start = function() {
            this.prepareQuestionnaire();
            this.$intro.hide();
            this.$questionnaire.show();
            this.scrollTop();
        };

        BaseQuiz.prototype.next = function(e) {
            var $currentStep = $(e.currentTarget).closest('.questionnaire__step');

            if (this.validateStep($currentStep)) {
                var nextStep = $currentStep.index() + 1;

                if (nextStep < this.$steps.length) {
                    var $nextStep = $(this.$steps[nextStep]);
                    this.switchToStep($nextStep);
                } else {
                    this.finish();
                }
            }
            this.scrollTop();
        };

        BaseQuiz.prototype.previous = function(e) {
            var $currentStep = $(e.currentTarget).closest('.questionnaire__step');
            var previousStep = $currentStep.index() - 1;
            var $previousStep = $(this.$steps[previousStep]);
            this.switchToStep($previousStep);
            this.scrollTop();
        };

        BaseQuiz.prototype.switchToStep = function($step) {
            if (this.prepareStep) {
                this.prepareStep($step);
            }

            this.$steps.hide();
            this.$steps.eq($step.index()).show();
        };

        BaseQuiz.prototype.finish = function() {
            this.prepareResult();
            this.$questionnaire.hide();
            this.$result.show();

            if (this.postUrl) {
                this.post();
            }

            this.scrollTop();
        };

        BaseQuiz.prototype.restart = function() {
            this.prepareQuestionnaire();
            this.$questionnaire.show();
            this.$result.hide();
            this.scrollTop();
        };

        BaseQuiz.prototype.scrollTop = function() {
            var navbarHeight = $('.navigation').height();
            var offset = this.$quiz.offset().top - navbarHeight;
            $('html, body').animate({ scrollTop: offset }, 100);
        };

        BaseQuiz.prototype.validateStep = function($step) {
            return $step.validateForm();
        };

        femcare.quiz.BaseQuiz = BaseQuiz;
    }
};
